<script>
import MeetingMixin from '../../mixins/meetingMixin';
import AllReceiptsMixin from '../../mixins/allReceiptsMixin';
import ButtonParent from "../parents/button-parent";
import {isReadyToRock} from "../../utilities/readiness.utilities";

export default {
    name: "download-receipts-button",
    extends: ButtonParent,
    props: [],

    mixins: [MeetingMixin, AllReceiptsMixin],

    data: function () {
        return {
            label: 'Download all receipts',
            styling: ' btn-primary text-light',
            icon: false
        }
    },

    computed: {
        filename: function () {
            let date = isReadyToRock(this.meetingDate) ? `${this.meetingDate} ` : '';
            return `${date}${this.meetingName} vote receipts.txt`;

        },
    },


    methods: {
        handleClick: function () {
            this.downloadFile();
        },

        downloadFile: function () {
            let element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.text));
            element.setAttribute('download', this.filename);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();
            document.body.removeChild(element);

            // download("hello.txt","This is the content of my file :)");

        }


    }


}
</script>

<style scoped>

</style>
